<template>
  <form method="POST" id="searchForm" class="AutocompleteComponent searchForm sidebar-form"
        style="overflow: visible"
        @submit.prevent
        action="">

    <div class="Autocomplete-input">
      <div class="input-group">
        <input type="text" name="q" id="searchField" class="form-control" placeholder="Rechercher..."
               autocomplete="off"
               v-model="query"
               @keydown.down="down"
               @keydown.up="up"
               @keydown.enter="hit"
               @keydown.esc="reset"
               @input="update"
               @focus="items.length>0 || (items.length==0 && query.length>0) ? showResults=true : showResults=false"
               @blur="showResults=false"
        />
        <span class="input-group-btn">
                    <button type="submit" name="search" id="search-btn" class="btn btn-flat" @submit.prevent>
                        <i class="fa"
                           :class="{'fa-search':!loading, 'fa-refresh': loading, 'fa-spin':loading }">
                        </i>
                    </button>
                </span>
      </div>
    </div>

    <ul class="results results-sidebar" v-show="showResults"
    >
      <li v-show="!hasItems">
        <div class="results_container">
          <div class="image">
          </div>
          <div class="description">
            <span class="titre red">Pas de résultat trouvé</span><br>
          </div>
        </div>
      </li>
      <li v-show="hasItems" class="ui-menu-item" role="presentation" v-for="(item,$index) in getOrderItems()"
          :class="activeClass($index)" @mousedown="onClick(item)" @mousemove="setActive($index)">
        <a href="#" :id="'ui-id-'+item.id"
           class="ui-corner-all padding5"
           tabindex="-1"
           @click="onClick(item)">
          <div class="results_container">
            <div class="image">
              <i class="glyphicon iconResults"
                 :class="[{'glyphicon-user':item.genre=='Monsieur'|| item.genre=='Madame', 'glyphicon-home':item.genre=='Club', }]"
              ></i>
            </div>
            <div class="description" v-if="item.type=='membre'">
              <span class="titre"> {{
                  item.fullName + " (n°" + item.numlicenceABFT + ") - " + item.phoneContact
                }}</span><br>
              <span class="desc" v-if="item.isLicencie">  <span
                class='text-green'>Licencié</span> - {{
                  item.numeroClubLastLicence
                }} {{ item.clubLastLicence ? item.clubLastLicence.toUpperCase() : "" }}</span>
              <span class="desc" v-if="!item.isLicencie">
                                <span class='text-red'>Licence expirée le {{ item.dateFinLastLicence }} </span> - <span
                class="desc">{{
                  item.numeroClubLastLicence
                }} {{ item.clubLastLicence ? item.clubLastLicence.toUpperCase() : "" }}</span>
                            </span>
            </div>
            <div class="description" v-if="item.type=='club'">
              <span class="titre"> {{ item.numero_club }} - {{ item.club ? item.club.toUpperCase() : "" }}</span><br>
              <span class="desc" v-if="item.isLicencie">  <span class='text-green'>Actif</span> - {{
                  item.nombre_membres
                }} membre{{ item.nombre_membres > 1 ? 's' : '' }}</span>
              <span class="desc" v-if="!item.isLicencie">  <span class='text-red'>Non-actif</span> - {{
                  item.nombre_membres
                }} membre{{ item.nombre_membres > 1 ? 's' : '' }}</span>
            </div>
            <div class="description" v-if="item.type=='recap'">
              <span class="titre"> [{{ item.id }}] - {{
                  item.numero_club
                }} - {{ item.club ? item.club.toUpperCase() : "" }} </span><br>
              <span class="desc" v-if="item.statut.meta=='done'">
                                <span class='text-green'>{{
                                    item.statut.type
                                  }}</span> - {{ item.nombre }} {{
                  item.nombre > 1 ? 'licences' : 'licence'
                }} - {{ item.total }}€
                             </span>
              <span class="desc" v-if="item.statut.meta=='wait_pay'">
                                <span class='text-info'>{{
                                    item.statut.type
                                  }}</span> - {{ item.nombre }} {{
                  item.nombre > 1 ? 'licences' : 'licence'
                }} - {{ item.total }}€
                             </span>
              <span class="desc" v-if="item.statut.meta=='cancelled'">
                                <span class='text-danger'>{{
                                    item.statut.type
                                  }}</span> - {{ item.nombre }} {{
                  item.nombre > 1 ? 'licences' : 'licence'
                }} - {{ item.total }}€
                             </span>
              <span class="desc"
                    v-if="item.statut.meta!='done' && item.statut.meta!='wait_pay' && item.statut.meta!='cancelled'  ">
                                <span class=''>{{
                                    item.statut.type
                                  }}</span> - {{ item.nombre }} {{
                  item.nombre > 1 ? 'licences' : 'licence'
                }} - {{ item.total }}€
                             </span>
            </div>
          </div>
        </a>
      </li>
    </ul>

  </form>
</template>


<script type="text/babel">
import {mapGetters, mapActions} from 'vuex'

var _ = require('underscore')
var moment = require('moment')

export default {
  data() {
    return {
      items: [],
      query: '',
      current: -1,
      loading: false,
      queryParamName: 'q',
      src: '',
      previousRequest: false,
      showResults: false,
      sizeOfResultBox: 400,
      defaultSizeForOneItem: 40,
      urlApi: null,
      minChars: 2,
      FollowLinkOnClickOnItem: true,
      showResultsBox: false,
      debounceRequest: null
    }
  },
  computed: {
    ...mapGetters({
      getRoute: 'getRoute'
    }),
    hasItems() {
      return this.items.length > 0
    },
    isEmpty() {
      return !this.query
    },
    isDirty() {
      return !!this.query
    }
  },
  props: {
    limit: {
      type: Number,
      default: function () {
        return 8
      }
    },
  },
  methods: {
    ...mapActions({}),
    getStatutRecap(statut) {
      switch (statut) {
        case 'En cours':
          return 'text-warning'
          break
        case 'En attente de décision':
          return 'text-warning'
          break
        case 'En attente':
          return 'text-warning'
          break
        case 'Annulé / Refusé':
          return 'text-danger'
          break
        case 'Cloturé / Validé':
          return 'text-green'
          break

        default:
          return ''
      }
    },

    debounce(fn, delay) {
      let timeoutID = null
      return function () {
        clearTimeout(timeoutID)
        let args = arguments
        let that = this
        timeoutID = setTimeout(function () {
          fn.apply(that, args)
        }, delay)
      }
    },

    getOrderItems() {
      // return _(this.items).chain().sortBy(function(item) {
      //     if (item.type=="membre") {
      //         return item.nom;
      //     }
      // }).sortBy(function(item) {
      //     return item.nameForSort;
      // }).value();

      return _.sortBy(this.items, 'isLicencie').reverse();
    },
//            showResults() {
//              if (this.items.length>0)
//                  this.showResultsBox=true
//                else
//                    this.showResultsBox=false
//            },
//
    update() {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(function () {
        if (!this.query) {
          return this.reset()
        }

        if (this.minChars && this.query.length < this.minChars) {
          return
        }

        this.loading = true
        this.fetch().then(function (response) {
          if (this.query) {
            let data = response.data
            data = this.prepareResponseData ? this.prepareResponseData(data) : data
//                        this.items = this.limit ? data.slice(0, this.limit) : data
            this.items = data
            this.current = -1
            this.loading = false
            this.showResults = true
          }
        })
      }.bind(this), 750);

    },
    fetch() {
      const params = this.queryParamName
        ? Object.assign({[this.queryParamName]: this.query}, this.data)
        : this.data

      const src = this.getRoute('generalSearch') + '?q=' + this.query

      return this.$http.get(src, {
        before(request) {
          // abort previous request, if exists
          if (this.previousRequest) {
            this.previousRequest.abort();
          }
          // set previous request on Vue instance
          this.previousRequest = request;
          this.loading = true
        }
      })
    },
    reset() {
      this.items = []
      this.query = ''
      this.loading = false
    },
    setActive(index) {
      this.current = index
    },
    activeClass(index) {
      return {
        active: this.current === index
      }
    },
    hit() {
      if (this.current !== -1) {
        this.onHit(this.items[this.current])
      }
    },
    up() {
      if (this.current > 0) {
        this.current--
      } else if (this.current === -1) {
        this.current = this.items.length - 1
      } else {
        this.current = -1
      }
    },
    down() {
      if (this.current < this.items.length - 1) {
        this.current++
      } else {
        this.current = -1
      }
    },
    onClick(item) {
      if (item.type == "membre")
        this.$router.push({name: 'Member', params: {member_id: item.id}})
      if (item.type == "club")
        this.$router.push({name: 'Club', params: {club_id: item.id}})
      if (item.type == "recap")
        this.$router.push({name: 'Recap', params: {recap_id: item.id}})
    }
  },
  watch: {
    items: function (value) {
      if (value.length == 0)
        return this.sizeOfResultBox = this.defaultSizeForOneItem

      this.sizeOfResultBox = this.limit * this.defaultSizeForOneItem
      if (value.length > this.limit)
        this.sizeOfResultBox = this.limit * this.defaultSizeForOneItem
    }
  },
  mounted: function () {
    let these = this
    this.debounceRequest = _.debounce(function () {
    }, 1000)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Communs/searchGeneral.vue